export { WelcomeText } from './WelcomeText';
